<h2 mat-dialog-title>New service agreement</h2>

<mat-dialog-content>
  <form [formGroup]="avtaleForm">
    <div class="container py-3">
      <div class="mb-3">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Agreement item <span class="text-danger">*</span></mat-label>
          <textarea
            matInput
            rows="7"
            formControlName="text"
            placeholder="E.g. 10 hot meals every day, access only from 07:00, must complete training to enter the building"
          ></textarea>
          <mat-error *ngIf="avtaleForm.get('text')?.invalid && avtaleForm.get('text')?.touched">
            Agreement item is required.
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div align="end" class="p-3 border-top">
      <button
        mat-raised-button
        color="primary"
        [disabled]="avtaleForm.invalid"
        (click)="saveAvtale()"
      >
        Save
      </button>
      <button mat-button mat-dialog-close>Close</button>
    </div>
  </form>
</mat-dialog-content>
